import { render } from "./DashboardApexChart.vue?vue&type=template&id=e3c78afc"
import script from "./DashboardApexChart.vue?vue&type=script&lang=js"
export * from "./DashboardApexChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__